// extracted by mini-css-extract-plugin
export default {"section":"Navigation__section--lc-rTJ5t","nav":"Navigation__nav--lc-vhiy4"};